export const accommodationNav = {
  ACCOMMODATION_NAV_LINK: 'accommodationNav.link'
}
